export default class NumberInput {
    /**
     * Create the NumberInput instance.
     * @param rootElement Wrapper element containing the input and counter buttons.
     */
    constructor(rootElement) {
        this.root = rootElement;
        if (this.root.classList.contains('number-input-initialized')) {
            return;
        }
        this.inputElement = this.root.querySelector('.number-input');
        this.buttonElements = this.root.querySelectorAll('.counter-btn');
        this.plusButton = this.root.querySelector('.counter-btn.plus');
        this.minusButton = this.root.querySelector('.counter-btn.minus');
        this.init();
        this.root.classList.add('number-input-initialized');
    }
    /**
     * Initialize event listeners.
     */
    init() {
        this.buttonElements.forEach((button) => {
            button.addEventListener('click', (event) => this.onButtonClick(event));
        });
        // update button states based on initial value
        if (this.inputElement) {
            this.updateButtonStates(parseInt(this.inputElement.value, 10) || 0);
            // update on input change
            this.inputElement.addEventListener('input', () => {
                const currentValue = parseInt(this.inputElement.value, 10) || 0;
                this.updateButtonStates(currentValue);
            });
        }
    }
    /**
     * Handle button clicks and update the associated input value.
     * @param event Click event.
     */
    onButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        if (button.disabled) {
            return;
        }
        const targetId = button.getAttribute('data-target');
        const isIncrement = button.classList.contains('plus');
        const input = this.getTargetInput(targetId);
        if (!input) {
            return;
        }
        const currentValue = parseInt(input.value, 10) || 0;
        const minValue = Number(input.min || input.getAttribute('data-min') || '0');
        const maxValue = Number(input.max || input.getAttribute('data-max') || '999');
        let newValue = isIncrement ? currentValue + 1 : currentValue - 1;
        newValue = Math.max(minValue, Math.min(maxValue, newValue));
        input.value = String(newValue);
        this.updateButtonStates(newValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    /**
     * Update the disabled state of plus/minus buttons based on current value.
     * @param currentValue Current input value.
     */
    updateButtonStates(currentValue) {
        if (!this.inputElement)
            return;
        const minValue = Number(this.inputElement.min || this.inputElement.getAttribute('data-min') || '0');
        const maxValue = Number(this.inputElement.max || this.inputElement.getAttribute('data-max') || '999');
        if (this.minusButton) {
            const isMinusDisabled = currentValue <= minValue;
            this.minusButton.disabled = isMinusDisabled;
            this.minusButton.setAttribute('aria-disabled', String(isMinusDisabled));
        }
        if (this.plusButton) {
            const isPlusDisabled = currentValue >= maxValue;
            this.plusButton.disabled = isPlusDisabled;
            this.plusButton.setAttribute('aria-disabled', String(isPlusDisabled));
        }
    }
    /**
     * Resolve the target input element by id or fallback to the first input inside the root.
     * @param targetId Optional input id from the button's data-target attribute.
     */
    getTargetInput(targetId) {
        if (targetId) {
            const resolved = document.getElementById(targetId);
            if (resolved && this.root.contains(resolved)) {
                return resolved;
            }
        }
        return this.inputElement;
    }
}
